import { useFlagContent } from '@lopo-tech/lopo-api'
import * as React from 'react'
import { useCallback } from 'react'

// components
import Submit from 'src/components/flag/create/steps/submit/submit'
import WriteFlag from 'src/components/flag/create/steps/write/write_flag'

// interfaces / constants
import { IFlagCreateData } from 'src/interfaces/flag'

type Step = 'write' | 'submit';

interface IProps {
  flaggableId?: string;
  onEnd: () => void;
}

const CreateFlagWizard: React.FC<IProps> = ({ flaggableId, onEnd }) => {
  const [step, setStep] = React.useState<Step>('write')
  const [data, setData] = React.useState<IFlagCreateData | undefined>(
    undefined
  )

  const [flagContent] = useFlagContent()

  const createFlag = useCallback((data: IFlagCreateData) => {
    flagContent({
      variables: {
        input: {
          flaggableId: flaggableId ?? '',
          message: data.message,
          reason: data.reason
        }
      }
    })
  }, [flaggableId])

  if (step === 'submit') {
    return <Submit data={data} onEnd={onEnd} onSubmit={createFlag} />
  }

  return (
    <WriteFlag
      onEnd={onEnd}
      onNext={(nextData) => {
        setData(nextData)
        setStep('submit')
      }}
    />
  )
}

export default CreateFlagWizard
